import { useState } from "react";
import type { CopyStrategy, GenerateOptions, GeneratedCopy, ProductSource } from "../../shared/types";
import { api, ApiError } from "../api";
import { CopyResult } from "./CopyResult";
import { GenerateForm } from "./GenerateForm";
import { SourceForm } from "./SourceForm";
import { SourceReview } from "./SourceReview";
import { StrategyView } from "./StrategyView";

export function ProductCopyApp() {
  const [source, setSource] = useState<ProductSource>();
  const [strategy, setStrategy] = useState<CopyStrategy>();
  const [copy, setCopy] = useState<GeneratedCopy>();
  const [busy, setBusy] = useState<"analyze" | "generate" | null>(null);
  const [error, setError] = useState("");

  async function analyze() {
    if (!source) return;
    setBusy("analyze"); setError("");
    try { setStrategy(await api<CopyStrategy>("/api/analyze", { method: "POST", body: JSON.stringify({ source }) })); }
    catch (cause) { setError(cause instanceof ApiError ? cause.message : "策略分析失敗。"); }
    finally { setBusy(null); }
  }
  async function generate(options: GenerateOptions) {
    if (!source || !strategy) return;
    setBusy("generate"); setError("");
    try { setCopy(await api<GeneratedCopy>("/api/generate", { method: "POST", body: JSON.stringify({ source, strategy, options }) })); }
    catch (cause) { setError(cause instanceof ApiError ? cause.message : "文案生成失敗。"); }
    finally { setBusy(null); }
  }
  function reset() { setSource(undefined); setStrategy(undefined); setCopy(undefined); setError(""); }

  return (
    <div className="app-shell">
      <header className="topbar"><div className="wordmark"><img className="brand-image small" src="/brand-icon.png" alt="" width="34" height="34" /><div><b>行銷武士道產品文案策略工具</b><small>幫你分析商品資訊，提煉出產品銷售的成交理由</small></div></div><div className="top-actions"><span className="version">MVP 0.4.7</span></div></header>
      <main className="workspace">
        <section className="intro"><p className="eyebrow">MARKETING SAMURAI</p><h1><span className="intro-title-line">行銷武士道</span><span className="intro-title-line">產品文案策略工具</span></h1><p>幫你分析商品資訊，提煉出產品銷售的成交理由</p></section>
        {!source && <SourceForm onComplete={(value) => { setSource(value); setStrategy(undefined); setCopy(undefined); }} />}
        {source && <SourceReview source={source} onReset={reset} onAnalyze={() => void analyze()} busy={busy === "analyze"} />}
        {error && <div className="global-error" role="alert">{error}</div>}
        {strategy && <StrategyView strategy={strategy} />}
        {strategy && <GenerateForm onGenerate={(options) => void generate(options)} busy={busy === "generate"} />}
        {copy && <CopyResult copy={copy} />}
      </main>
      <footer>商品內容仍應由品牌確認事實、證據與法規適用性。系統不會自動把推論當成已證實宣稱。</footer>
    </div>
  );
}
